import { useSelector } from "react-redux";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis.tsx";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectTabularFields, selectTabularGrouping } from "../../../../store/selectors/fieldsStateSelectors";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks";
import SwitchField from "../../../common/SwitchField";
import { getDisplayCaption } from "../../../viewer/common/fields/field-captions/captionsHelper.ts";
import ExpandeGroup from "./ExpandeGroup.tsx";
import StyleItem from "./StyleItem.tsx";

export default function GroupSettings({ readonlyMode }: { readonlyMode: boolean }) {
  const fieldsAreaValues = useSelector(selectTabularFields);
  const grouping = useSelector(selectTabularGrouping);
  const dispatch = useAppDispatch();

  return (
    <>
      {grouping.length > 0 && (
        <ExpandeGroup title="Grouped Columns">
          {grouping.map((group, index) => {
            const field = fieldsAreaValues.find((f) => f.config.guid === group.id);
            if (!field) {
              return null;
            }
            return (
              <StyleItem key={group.id} showBorder={grouping.length > 1 && index < grouping.length - 1}>
                <TypographyTooltipEllipsis
                  typographyProps={{
                    variant: "subtitle2",
                    sx: { pb: 1, width: "100%", fontWeight: 500 },
                  }}
                  text={getDisplayCaption(field.meta.caption, field.config.customLabel, field.config.systemLabel)}
                />
                <SwitchField
                  label="Show Subtotals"
                  checked={!group.hideSummaries}
                  onChange={(hideSummaries) =>
                    dispatch(
                      fieldsStateActions.updateGroup({
                        group,
                        changes: { hideSummaries: !hideSummaries },
                      })
                    )
                  }
                  typographyProps={{ sx: { color: "text.secondary" } }}
                  disabled={readonlyMode}
                />
              </StyleItem>
            );
          })}
        </ExpandeGroup>
      )}
    </>
  );
}
